/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import 'moment/min/locales';
import { FormattedMessage } from 'react-intl';
import { renderInfoForType } from '../../../../utils/helpers';
import Status from '../../List/components/Status';
import styles from '../../../../styles/general.module.scss';
import Button from '../../../../components/button/button';
import { hostName, isLocal } from '../../../../constants';
import { cancelRequest } from '../../redux/actions';
import DeleteConfirmation from '../../../../components/deleteConfirmation/deleteConfirmation';

const Table = ({ info, airportCode, Id, getData, cancelData, baseTitle, enable_service_request }) => {
  const [confirmModal, setConfirmModal] = useState(false);
  const [id, setId] = useState('');
  const [comment, setComment] = useState('');
  const cancelrequest = useSelector(state => state?.lease?.cancelRequest);
  const dispatch = useDispatch();
  const url = hostName?.slice(6);
  const apiCall = useCallback((newInfo) => {
    getData(newInfo);
  }, [getData]);

useEffect(() => {
  if (cancelrequest?.success === true) {
    apiCall(cancelData?.applications);
    setConfirmModal(false);
  }
}, [cancelrequest, cancelData, apiCall]);
  const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${Id}${url}/public`;
  const remove = async () => {
    const phonenumber = localStorage.getItem('phoneNumber');
    const payload = {
    comment,
    status: 10,
    phonenumber
   };
    try {
     dispatch(cancelRequest(publicUrl, id, payload, airportCode));
     setConfirmModal(false);
    } catch (err) {
    // nothing
    }
  };

  const toggleConfirmDelete = () => {
    setConfirmModal(false);
  };

  const handleComment = (value) => {
    setComment(value);
  };

  return (
  <><div className={styles.responsiveTable}>

        <table className={styles.table} style={{ marginTop: '10px' }}>
            <thead>
              <tr>
                <th>
                  <FormattedMessage id="workorder.detail.request.workorder" defaultMessage={`${baseTitle} #`} />
                </th>
                <th>
                  <FormattedMessage id="job.settings.type_name" defaultMessage="Date" />
                </th>
                <th>
                  <FormattedMessage id="workorders.list.table.description" defaultMessage="Description" />
                </th>
                <th>
                  <FormattedMessage id="workorders.list.table.category" defaultMessage="Category" />
                </th>
                <th>
                  <FormattedMessage id="workorders.list.table.status" defaultMessage="Status" />
                </th>
                <th width="80" />
              </tr>
            </thead>
            <tbody>
              {!info?.length > 0 ? (
                <tr>
                  <td className="noTableData" colSpan={7}>
                    <FormattedMessage id="WorkOrders.list.table.no_results" defaultMessage="There are no workorders on the selected range" />
                  </td>
                </tr>
              )
                : (
                  info?.map(e => (
                    <tr key={e?.id}>
                      <td>
                        {enable_service_request === true ? e?.order_number : `N-${e?.order_number}`}
                      </td>
                      <td>{renderInfoForType({ 'type': 'datetime' }, e?.report_date, null, null)}</td>
                      <td title={e?.problem_description}>{e?.problem_description}</td>
                      <td>{e?.category}</td>
                      <td><Status
                        item={
                          e?.status === 'Cancel'
                            ? 'Cancelled'
                            : e?.status === 12
                            ? e
                            : e?.status
                        }
                      />
                      </td>
                      <td>
                      {!info?.maintenance_answer && e?.status !== 'Cancel' && (
                      <Button
                        action={'tertiary'}
                        onClick={() => {
                          setId(e?.id);
                          setConfirmModal(true);
                        }}
                        translationID="inspections.new.cancelBtn"
                        defaultText="Cancel" />
                      )}
                      </td>
                    </tr>

                  ))
                )}
            </tbody>
        </table>

    </div>
      <div className={styles.mobileCards}>
        <div className={styles.cardsGrid}>
          {!info?.length > 0 ? (
            <div className={styles.noDataCard}>
              <FormattedMessage id="WorkOrders.list.table.no_results" defaultMessage="There are no workorders on the selected range" />
            </div>
          ) : (
            info?.map(e => (
              <div key={e.id} className={styles.tableCard}>
                <div className={styles.cardRow}>
                  <div className={styles.column}>
                    <div className={styles.cardLabel}>
                      <FormattedMessage id="workorder.detail.request.workorder" defaultMessage={`${baseTitle} #`} />
                    </div>
                    <div className={styles.cardValue}>
                      {enable_service_request === true ? e?.order_number : `N-${e?.order_number}`}
                    </div>
                  </div>
                  <div className={styles.column}>
                    <div className={styles.cardLabel}>
                      <FormattedMessage id="job.settings.type_name" defaultMessage="Date" />
                    </div>
                    <div className={styles.cardValue}>
                      {renderInfoForType({ 'type': 'datetime' }, e.report_date, null, null)}
                    </div>
                  </div>
                </div>

                <div className={styles.cardRow}>
                  <div className={styles.fullColumn}>
                    <div className={styles.cardLabel}>
                      <FormattedMessage id="workorders.list.table.category" defaultMessage="Category" />
                    </div>
                    <div className={styles.cardValue}>
                      {e?.category}
                    </div>
                  </div>
                </div>

                <div className={styles.cardRow}>
                  <div className={styles.fullColumn}>
                    <div className={styles.cardLabel}>
                      <FormattedMessage id="workorders.list.table.description" defaultMessage="Description" />
                    </div>
                    <div className={styles.cardValue} title={e?.problem_description}>
                      <span className={styles.truncateText}>{e?.problem_description}</span>
                    </div>
                  </div>
                </div>

                <div className={styles.divider} />

                <div className={`${styles.cardRow} ${styles.reverseOnMobile}`}>
                  <div className={styles.column}>
                    <div className={styles.cardActions}>
                      {!info?.maintenance_answer && e?.status !== 'Cancel' && (
                        <Button
                          action={'tertiary'}
                          onClick={() => {
                            setId(e?.id);
                            setConfirmModal(true);
                          }}
                          translationID="inspections.new.cancelBtn"
                          defaultText="Cancel"
                        />
                      )}
                    </div>
                  </div>
                  <div className={styles.column}>
                    <div className={styles.cardLabel}>
                      <FormattedMessage id="workorders.list.table.status" defaultMessage="Status" />
                    </div>
                    <div className={styles.cardValue}>
                    <Status
                    item={
                      e?.status === 'Cancel'
                        ? 'Cancelled'
                        : e?.status === 12
                        ? e
                        : e?.status
                    }
                  />
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    <DeleteConfirmation
        isActive={confirmModal}
        onClose={() => toggleConfirmDelete()}
        confirmDelete={() => remove()}
        cancelRequest
        comment={comment}
        handleAnswerChanged={value => handleComment(value)}
      />
  </>
);
};

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapStateToProps = state => ({
  cancelData: state.lease.cancelData
});
export default connect(mapStateToProps)(Table);
